import initialState from "./initialState";

export function AuditTrailReducer(
  state = initialState.auditTrailFormValues,
  action
) {
  switch (action.type) {
    case "AUDIT_TRAIL_FORM_DATA_REQUEST":
      return action.payload;
    default:
      return state;
  }
}
